import React from 'react';

const PlusSign = () => {
    return (
        <svg
            width='30'
            height='31'
            viewBox='0 0 30 31'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15 7.01135C15.5523 7.01135 16 7.40932 16 7.90024V22.1225C16 22.6134 15.5523 23.0114 15 23.0114C14.4477 23.0114 14 22.6134 14 22.1225V7.90024C14 7.40932 14.4477 7.01135 15 7.01135Z'
                fill='#808080'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7 15.0114C7 14.4591 7.39797 14.0114 7.88889 14.0114H22.1111C22.602 14.0114 23 14.4591 23 15.0114C23 15.5636 22.602 16.0114 22.1111 16.0114H7.88889C7.39797 16.0114 7 15.5636 7 15.0114Z'
                fill='#808080'
            />
        </svg>
    );
};

export default PlusSign;
